import { Injectable, PLATFORM_ID, Inject, Injector } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { TransferState, makeStateKey } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { API_PATH, SUBSCRIPTION_KEY, GET_DATE_TIME} from '../../shared/globals';

// Assuming you have your package.json file in the assets folder
import packageJson from '../../../../package.json';
// external libs
import moment from 'moment';

declare var System: any;

const DATE_TIME_KEY = makeStateKey('date_time_key');

let csValue = null;


@Injectable({
  providedIn: 'root',
})
export class UtilityService {

  private _appV: string;

  public csHead$: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor (
    private _http: HttpClient,
    private _serverState: TransferState
  ) {
      this._appV = packageJson.version;
      this.cs();
  }

  cs(num = 559632145) {

    const dateTimeValue = this._serverState.get(DATE_TIME_KEY, null as any);

    if (!dateTimeValue) {
      this.getDateTime().then((dt: string) => {

        // static prime number arr - used for div number
        const pArr = [5, 7, 11, 13];
        // get odd index numbers from passed in num
        const oddNum = this.getOddNumbersIndex(num);
        // set random range, i.e. 0 - 9
        const rRange = 10;
        // generate number from 0 - 9 - round down
        const r = Math.floor(Math.random() * rRange);
        // add oddNum vals together, then add random number
        const sumArr = (oddNum.reduce((a, b) => { return a + b; }) + r);
        // find prime number by index by div random number by 3 - round down
        const pNum = pArr[Math.floor(r % 3)];
        // find reminder for sum / prime number
        const rem = sumArr % pNum;
        // round value down of sumArr / pNum
        const divider = Math.floor(sumArr / pNum);
        // get current date
        const date = moment(dt);
        // get hour value - round up depedning on min value - check if 2 chars
        // const h = this.checkLength(date.hours());
        // get day value - check if 2 chars
        const d = this.checkLength(date.date());

        // concat values together
        const newVal = `${d}${num}${r}${rem}${divider}`;

        // set in server state and notify subscribers
        this._serverState.set(DATE_TIME_KEY, newVal as any);
        this.csHead$.next(newVal);
        csValue = newVal;

      })
      .catch((err) => { console.log(err); });

    } else {
      this.csHead$.next(dateTimeValue);
      csValue = dateTimeValue;
    }

  };


  getCsValue() {
    return csValue;
  }

  getDateTime = () => {

    const promise = new Promise((resolve, reject) => {

    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    const headers = new HttpHeaders()
    .set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);

      this._http.get(API_PATH + GET_DATE_TIME + '?cache=' + (Math.random() * 1000000), {headers: headers})
      .toPromise()
      .then((res:any) => {
        // Normalize response to a date string. API may return a plain string or an object
        let dt: any = res;
        if (res && typeof res === 'object') {
          if (typeof res === 'object' && typeof (res.currentDateTime || res.CurrentDateTime) === 'string') {
            dt = res.currentDateTime || res.CurrentDateTime;
          }
          else if (typeof res.dateTime === 'string') {
            dt = res.dateTime;
          }
          else if (typeof res.value === 'string') {
            dt = res.value;
          }
          else {
            // try to find first ISO-like string value in the object
            for (const k of Object.keys(res)) {
              if (typeof res[k] === 'string' && /\d{4}-\d{2}-\d{2}T/.test(res[k])) {
                dt = res[k];
                break;
              }
            }
          }
        }

        resolve(dt);
      })
      .catch(err => { reject('error loading date'); });
    });

    return promise;
  }

  getPrimeNumberToN = (range) => {

    const primeArr = [];
    const checkNumber = (num) => {
      if (this.isPrime(num)) {
        primeArr.push(num);
      }
    };

    for (let i = 1; primeArr.length < range; i++) {
      checkNumber(i);
    }

    return primeArr;

  }

  isPrime = (n) => {

    const arr = [];

    if (n === 1) {
      return false;
    } else {
      for (let i = 2; i < n; i++) {
        if (n % i === 0) { return false; }
      }
      return true;
    }

  }

  getOddNumbersIndex = (v) => {
    const numArr = v.toString().split('').map(Number);
    const oddArr = numArr.filter((s, i) => { if ((i + 1) % 2 !== 0) { return s; } });
    return oddArr;
  }

  getOddNumbers = (v) => {
    const numArr = v.toString().split('').map(Number);
    // const sortedArr = numArr.sort((a, b) => a - b);
    const oddArr = numArr.filter((s) => { if (s % 2 !== 0) { return s; }});
    return oddArr;
  }

  checkLength = (val) => {
    let result = '';

    if (val.toString().length === 1) { result = '0' + val; } else { result = val; }
    return result;
  }

  stringToNumberArr = (str, arr) => {
    for (let i = 0; i < str.length; i++) {
      arr.push(parseInt(str[i], 10));
    }
    return arr;
  }

}
